import React, { useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../../../assets/icons/rightArrow.svg";
import { ReactComponent as DownArrow } from "../../../../assets/icons/downArrow.svg";
import { ReactComponent as CopyIcon } from "../../../../assets/icons/copy.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/closeIcon.svg";
import Button from "../../../../../common/components/button";
import TableName from "../../../../components/common/tableName";
import Toggle from "../../../../components/common/toggle";
import Input from "../../../../components/common/input";
import CheckBox from "../../../../components/common/checkBox";
import { GetCustomerResponse } from "../../../../../common/hooks/console/management/customer/useGetCustomerInfo";
// import SearchAddress from "../../../../components/common/searchAddress";
import { usePutCustomerInfo } from "../../../../../common/hooks/console/management/customer/usePutCustomerInfo";
import useToastStore from "../../../../store/useToastStore";
import { useDeleteCustomer } from "../../../../../common/hooks/console/management/customer/useDeleteCustomer";
import { useSystemPopStore } from "../../../../store/useSystemPopStore";
import SystemPop from "../../../../components/common/systemPop";
import { usePutCustomerOption } from "../../../../../common/hooks/console/management/customer/usePutCustomerOption";
import { useGetCustomerMemo } from "../../../../../common/hooks/console/management/customer/useGetCustomerMemo";
import { usePostCustomerMemo } from "../../../../../common/hooks/console/management/customer/usePostCustomerMemo";
import { usePutCustomerMemo } from "../../../../../common/hooks/console/management/customer/usePutCustomerMemo";
import { useDeleteCustomerMemo } from "../../../../../common/hooks/console/management/customer/useDeleteCustomerMemo";
import { useGetCustomerManager } from "../../../../../common/hooks/console/management/customer/useGetCustomerManager";
import { usePostCustomerManager } from "../../../../../common/hooks/console/management/customer/usePostCustomerManager";
import { useDeleteCustomerManager } from "../../../../../common/hooks/console/management/customer/useDeleteCustomerManager";
import { usePutCustomerManager } from "../../../../../common/hooks/console/management/customer/usePutCustomerManager";
import {
    GetCustomerCategoryResponse,
    useGetCustomerCategory,
} from "../../../../../common/hooks/console/management/customer/useGetCustomerCategory";
import { usePutCustomerCategory } from "../../../../../common/hooks/console/management/customer/usePutCustomerCategory";
import {
    GetCustomerEventContentResponse,
    useGetCustomerEventContent,
} from "../../../../../common/hooks/console/management/customer/useGetCustomerEventContent";
import { usePutCustomerEventContent } from "../../../../../common/hooks/console/management/customer/usePutCustomerEventContent";
import { useGetCustomerSender } from "../../../../../common/hooks/console/management/customer/useGetCustomerSender";
import { usePostCustomerSender } from "../../../../../common/hooks/console/management/customer/usePostCustomerSender";
import { useDeleteCustomerSender } from "../../../../../common/hooks/console/management/customer/useDeleteCustomerSender";
import { usePutCustomerSenderStatus } from "../../../../../common/hooks/console/management/customer/usePutCustomerSenderStatus";
import { usePutCustomerSender } from "../../../../../common/hooks/console/management/customer/usePutCustomerSender";
import { useAuthStore } from "../../../../store/useAuthStore";
import NewOrderSearchAddress from "console/components/common/newOrderSearchAddress";

interface CustomerInfoProps {
    data?: GetCustomerResponse;
    id: number;
    onComplete: (id: number) => void;
}

const CustomerInfo = ({ data, id, onComplete }: CustomerInfoProps) => {
    // console.log('data',data);

    const level = useAuthStore(state => state.m_level);
    const name = useAuthStore(state => state.m_name);
    const containerRef = useRef<HTMLDivElement>(null!);
    const customerRef = useRef<HTMLDivElement>(null!);
    const managerRef = useRef<HTMLDivElement>(null!);
    const ownerRef = useRef<HTMLDivElement>(null!);
    const categoryRef = useRef<HTMLDivElement>(null!);

    const { addToast } = useToastStore();
    const { showPop } = useSystemPopStore();

    const initialState = {
        status: data?.status || true,
        customerName: data?.customer_name || "",
        zoneCode: data?.customer_post || "",
        address: data?.customer_address || "",
        detailAddress: data?.customer_address_detail || "",
    };

    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [editMemo, setEditMemo] = useState("");
    const [activeSection, setActiveSection] = useState<string>("customer");
    const [scrolling, setScrolling] = useState<boolean>(false);
    const [customerMemo, setCustomerMemo] = useState<string>("");
    const [status, setStatus] = useState<boolean>(data?.status || true);
    const [customerName, setCustomerName] = useState<string>(data?.customer_name || "");
    const [zoneCode, setZoneCode] = useState<string>(data?.customer_post || "");
    const [address, setAddress] = useState<string>(data?.customer_address || "");
    const [detailAddress, setDetailAddress] = useState<string>(data?.customer_address_detail || "");
    const [managerPop, setManagerPop] = useState<boolean>(false);
    const [managerModifyPop, setManagerModifyPop] = useState<number | null>(null);
    const [senderPop, setSenderPop] = useState<boolean>(false);
    const [senderModifyPop, setSenderModifyPop] = useState<number | null>(null);
    const [currentPageManager, setCurrentPageManager] = useState<number>(1);
    const [searchTxtManager, setSearchTxtManager] = useState<string>("");
    const [currentPageSender, setCurrentPageSender] = useState<number>(1);
    const [searchTxtSender, setSearchTxtSender] = useState<string>("");
    const [managerName, setManagerName] = useState<string>("");
    const [managerContact, setManagerContact] = useState<string>("");
    const [managerEmail, setManagerEmail] = useState<string | null>(null);
    const [isUnionEnabled, setIsUnionEnabled] = useState(false);
    const [isShowEnabled, setIsShowEnabled] = useState(false);
    const [senderDefault, setSenderDefault] = useState<string>("");
    const [senderUnion, setSenderUnion] = useState<string>("");
    const [options, setOptions] = useState({
        event_content_option: false,
        related_person_option: false,
        work_location_option: false,
        department_option: false,
        union_option: false,
        company_tel_option: false,
        wreath_sender_option: false,
        wreath_word_option: false,
    });
    const [checkedCategories, setCheckedCategories] = useState<number[]>([]);
    const [checkedEventContents, setCheckedEventContents] = useState<number[]>([]);
    const [eventContentList, setEventContentList] = useState<GetCustomerEventContentResponse[]>([]);

    const [customerNameError, setCustomerNameError] = useState(false);
    const [managerNameError, setManagerNameError] = useState(false);
    const [managerContactError, setManagerContactError] = useState(false);
    const [senderDefaultError, setSenderDefaultError] = useState(false);
    const [senderUnionError, setSenderUnionError] = useState(false);
    const [unionErrorMessage, setUnionErrorMessage] = useState("");
    const [unionModifyErrorMessage, setUnionModifyErrorMessage] = useState("");
    const [collapsedSections, setCollapsedSections] = useState<{ [key: string]: boolean }>({
        customer: false,
        option: false,
        eventContent: false,
        memo: false,
    });

    const toggleSection = (section: string) => {
        setCollapsedSections(prev => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    //고객정보 관리 (수정,삭제)
    const putCustomerOptionMutation = usePutCustomerOption();
    const putCustomerMutation = usePutCustomerInfo(() => {
        addToast({
            type: "success",
            message: "고객정보가 변경되었습니다.",
        });
    });
    const handleSave = () => {
        let hasError = false;
        if ((customerName?.trim() ?? "") === "") {
            setCustomerNameError(true);
            hasError = true;
        }
        if (hasError) return;

        const payload = {
            id: id,
            data: {
                status,
                customer_name: customerName,
                customer_post: zoneCode,
                customer_address: address,
                customer_address_detail: detailAddress,
            },
        };
        putCustomerMutation.mutate(payload);
    };
    const deleteCustomerMutation = useDeleteCustomer();
    const handleDelete = () => {
        showPop({
            title: "해당 내역을 삭제하시겠습니까",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                addToast({
                    type: "delete",
                    onConfirmDelete: () =>
                        deleteCustomerMutation.mutate(
                            { id },
                            {
                                onSuccess: () => {
                                    onComplete(id);
                                },
                            },
                        ),
                });
            },
        });
    };
    const handleCancel = () => {
        setCustomerName(initialState.customerName);
        setZoneCode(initialState.zoneCode);
        setAddress(initialState.address);
        setDetailAddress(initialState.detailAddress);
        setStatus(initialState.status);

        setCustomerNameError(false);
    };

    //메모 관리 (등록, 수정, 삭제)
    const { mutate: memoMutate } = usePostCustomerMemo(() => setCustomerMemo(""), id);
    const { mutate: memoModifyMutate } = usePutCustomerMemo(() => setEditIndex(null));
    const { data: memoData } = useGetCustomerMemo(id);
    const deleteCustomerMemoMutation = useDeleteCustomerMemo();
    const handleMemoSave = () => {
        customerMemo &&
            memoMutate({
                customer_memo: customerMemo,
            });
    };
    const handleMemoModify = (customerId: number, memoId: number) => {
        editMemo &&
            memoModifyMutate({
                customerId,
                memoId,
                customerMemoData: { customer_memo: editMemo },
            });
    };
    const handleEdit = (memoId: number, memo: string) => {
        setEditIndex(memoId);
        setEditMemo(memo);
    };
    const handleMemoCancel = () => {
        setEditIndex(null);
        setEditMemo("");
    };
    const handleMemoDelete = (customerId: number, memoId: number) => {
        deleteCustomerMemoMutation.mutate({
            customerId,
            memoId,
        });
    };

    // 담당자 관리
    const { mutate: managerMutate } = usePostCustomerManager(() => {
        setManagerName("");
        setManagerEmail(null);
        setManagerContact("");
        setManagerPop(false);
    }, id);
    const { data: managerData } = useGetCustomerManager(id, currentPageManager, searchTxtManager);
    const { mutate: managerModifyMutate } = usePutCustomerManager(
        () => {
            setManagerName("");
            setManagerEmail(null);
            setManagerContact("");
            setManagerModifyPop(null);
        },
        id,
        managerModifyPop || 0,
    );
    const deleteCustomerManagerMutation = useDeleteCustomerManager();
    const handleManagerPageChange = (page: number) => {
        setCurrentPageManager(page);
    };
    const handleManagerAdd = () => {
        setManagerPop(true);
        setManagerModifyPop(null);
        setManagerName("");
        setManagerContact("");
        setManagerEmail(null);
    };
    const handleManagerSave = () => {
        let hasError = false;
        if ((managerName?.trim() ?? "") === "") {
            setManagerNameError(true);
            hasError = true;
        }
        if ((managerContact?.trim() ?? "") === "") {
            setManagerContactError(true);
            hasError = true;
        }
        if (hasError) return;
        managerMutate(
            {
                manager_name: managerName,
                manager_mobile: managerContact,
                manager_email: managerEmail || null,
            },
            {
                onError: (error: any) => {
                    const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                    showPop({
                        title: errorMessage,
                        rightButton: undefined,
                        type: "negative",
                        onRightClick: () => {},
                    });
                },
            },
        );
    };
    const handleManagerModify = () => {
        let hasError = false;
        if ((managerName?.trim() ?? "") === "") {
            setManagerNameError(true);
            hasError = true;
        }
        if ((managerContact?.trim() ?? "") === "") {
            setManagerContactError(true);
            hasError = true;
        }
        if (hasError) return;
        managerModifyMutate(
            {
                manager_name: managerName,
                manager_mobile: managerContact,
                manager_email: managerEmail || null,
            },
            {
                onError: (error: any) => {
                    const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                    showPop({
                        title: errorMessage,
                        rightButton: undefined,
                        type: "negative",
                        onRightClick: () => {},
                    });
                },
            },
        );
    };
    const handleManagerDelete = (customerId: number, managerId: number) => {
        deleteCustomerManagerMutation.mutate({
            customerId,
            managerId,
        });
    };
    const handleManagerEdit = (manager: any) => {
        setManagerModifyPop(prev => (prev === manager.customer_manager_idx ? null : manager.customer_manager_idx));
        setManagerPop(false);
        setManagerName(manager.manager_name);
        setManagerContact(manager.manager_mobile);
        setManagerEmail(manager.manager_email);
    };
    const handleManagerEditClose = () => {
        setManagerModifyPop(null);
    };
    useEffect(() => {
        setCurrentPageManager(1);
    }, [searchTxtManager]);

    // 명의 관리
    const { data: senderData } = useGetCustomerSender(id, currentPageSender, searchTxtSender);
    const { mutate: senderMutate } = usePostCustomerSender(() => {
        setSenderPop(false);
        setIsUnionEnabled(false);
        setSenderDefault("");
        setSenderUnion("");
    }, id);
    const { mutate: updateSenderStatus } = usePutCustomerSenderStatus();
    const { mutate: senderModifyMutate } = usePutCustomerSender(() => setSenderModifyPop(null), id, senderModifyPop || 0);

    const hasUnionOption = senderData?.data_list?.some(sender => sender.union_option === true);

    useEffect(() => {
        if (hasUnionOption) {
            setIsUnionEnabled(false);
        }
    }, [hasUnionOption]);
    const handleToggleStatus = (senderId: number, currentStatus: boolean) => {
        updateSenderStatus({ id, senderId });
    };
    const handleSenderSave = () => {
        let hasError = false;
        setUnionErrorMessage("");

        if (!senderDefault.trim()) {
            setSenderDefaultError(true);
            hasError = true;
        }
        if (isUnionEnabled && !senderUnion.trim()) {
            setSenderUnionError(true);
            hasError = true;
        }
        if (hasError) return;

        senderMutate(
            {
                union_option: isUnionEnabled,
                default_sender: senderDefault,
                union_sender: senderUnion,
            },
            {
                onError: (error: any) => {
                    setUnionErrorMessage(error.message);
                },
            },
        );
        setSenderDefaultError(false);
        setSenderUnionError(false);
    };
    const handleSenderPageChange = (page: number) => {
        setCurrentPageSender(page);
    };
    const deleteCustomerSenderMutation = useDeleteCustomerSender();
    const handleSenderDelete = (customerId: number, senderId: number) => {
        deleteCustomerSenderMutation.mutate({
            customerId,
            senderId,
        });
    };
    useEffect(() => {
        setCurrentPageSender(1);
    }, [searchTxtSender]);
    const handleSenderAdd = () => {
        setSenderPop(true);
        setSenderModifyPop(null);
        setIsUnionEnabled(false);
        setSenderDefault("");
        setSenderUnion("");
    };
    const handleSenderEdit = (sender: any) => {
        setSenderModifyPop(prev => (prev === sender.sender_idx ? null : sender.sender_idx));
        setSenderPop(false);
        setSenderDefault(sender.default_sender);
        setSenderUnion(sender.union_sender);
        setIsUnionEnabled(sender.union_option);
        setIsShowEnabled(sender.status);
    };
    const handleSenderModify = () => {
        let hasError = false;
        setUnionModifyErrorMessage("");
        if (!senderDefault) {
            setSenderDefaultError(true);
            hasError = true;
        }
        if (isUnionEnabled && !senderUnion) {
            setSenderUnionError(true);
            hasError = true;
        }
        if (hasError) return;

        senderModifyMutate(
            {
                union_option: isUnionEnabled,
                default_sender: senderDefault,
                union_sender: senderUnion,
                status: isShowEnabled,
            },
            {
                onError: (error: any) => {
                    setUnionModifyErrorMessage(error.message);
                },
            },
        );
        setSenderDefaultError(false);
        setSenderUnionError(false);
        setUnionErrorMessage("");
    };
    const handleSenderCancel = () => {
        setSenderPop(false);
        setSenderDefault("");
        setSenderUnion("");
        setIsUnionEnabled(false);
        setSenderDefaultError(false);
        setSenderUnionError(false);
        setUnionErrorMessage("");
        setUnionErrorMessage("");
    };
    const handleSenderEditClose = () => {
        setSenderModifyPop(null);
        setSenderDefault("");
        setSenderUnion("");
        setIsUnionEnabled(false);
        setSenderDefaultError(false);
        setSenderUnionError(false);
        setUnionModifyErrorMessage("");
    };

    // 카테고리 관리
    const { data: categoryData } = useGetCustomerCategory(id);
    const { mutate: managerCategoryMutate } = usePutCustomerCategory(undefined);
    const [categoryList, setCategoryList] = useState<GetCustomerCategoryResponse[]>([]);

    const handleCategoryUpdate = () => {
        managerCategoryMutate(
            {
                id,
                product_category_idx: checkedCategories,
            },
            {
                onSuccess: () => {
                    addToast({
                        type: "success",
                        message: "상품 카테고리 설정을 저장하였습니다.",
                    });
                },
            },
        );
    };

    const handleCategoryChange = (productCategoryId: number) => {
        setCheckedCategories(prev =>
            prev.includes(productCategoryId) ? prev.filter(id => id !== productCategoryId) : [...prev, productCategoryId],
        );
    };
    const handleSelectAll = () => {
        const allChecked = categoryList.every(category => checkedCategories.includes(category.product_category_idx));
        setCheckedCategories(allChecked ? [] : categoryList.map(category => category.product_category_idx));
    };

    // 경조내용 관리
    const { data: eventContentData } = useGetCustomerEventContent(id);
    const { mutate: eventContentMutate } = usePutCustomerEventContent(undefined);

    const handleEventContentUpdate = () => {
        eventContentMutate(
            {
                id,
                event_content_idx: checkedEventContents,
            },
            {
                onSuccess: () => {
                    addToast({
                        type: "success",
                        message: "경조내용 설정을 저장하였습니다.",
                    });
                },
            },
        );
    };

    const handleEventContentChange = (eventContentIdx: number) => {
        setCheckedEventContents(prev =>
            prev.includes(eventContentIdx) ? prev.filter(id => id !== eventContentIdx) : [...prev, eventContentIdx],
        );
    };

    const handleEventContentSelectAllByDepth1 = (depth1Idx: number) => {
        const depth1Items = eventContentList.filter(item => item.depth1_idx === depth1Idx);
        const allChecked = depth1Items.every(item => checkedEventContents.includes(item.event_content_idx));
        if (allChecked) {
            setCheckedEventContents(prev => prev.filter(id => !depth1Items.map(item => item.event_content_idx).includes(id)));
        } else {
            const newIds = depth1Items.map(item => item.event_content_idx).filter(id => !checkedEventContents.includes(id));
            setCheckedEventContents(prev => [...prev, ...newIds]);
        }
    };

    //토글 관리
    const handleOptionToggle = (key: keyof typeof options, optionId: number) => {
        setOptions(prev => {
            const updatedOptions = { ...prev, [key]: !prev[key] };
            putCustomerOptionMutation.mutate({
                id,
                optionId,
            });

            return updatedOptions;
        });
    };

    //주소 관리
    const handleAddressChange = (newZoneCode: string, newAddress: string, newDetailAddress: string) => {
        setZoneCode(newZoneCode);
        setAddress(newAddress);
        setDetailAddress(newDetailAddress);
    };

    // 스크롤 관리
    const sectionsRef = useRef([
        { ref: customerRef, section: "customer" },
        { ref: managerRef, section: "manager" },
        { ref: ownerRef, section: "owner" },
        { ref: categoryRef, section: "category" },
    ]);
    const handleScrollEvent = useCallback(() => {
        if (!containerRef.current || scrolling) return;

        let detectedSection = activeSection;
        const viewportHeight = window.innerHeight;
        const middleOfScreen = viewportHeight / 4;

        for (const { ref, section } of sectionsRef.current) {
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();

                if (rect.top <= middleOfScreen && rect.bottom >= middleOfScreen) {
                    detectedSection = section;
                    break;
                }
            }
        }

        if (detectedSection !== activeSection) {
            setActiveSection(detectedSection);
        }
    }, [activeSection, scrolling]);
    const handleScroll = useCallback((ref: React.RefObject<HTMLDivElement>, section: string) => {
        if (ref.current && containerRef.current) {
            setActiveSection(section);
            setScrolling(true);

            containerRef.current.scrollTo({
                top: ref.current.offsetTop - containerRef.current.offsetTop,
                behavior: "smooth",
            });

            setTimeout(() => {
                setScrolling(false);
            }, 500);
        }
    }, []);

    // 전화번호 포맷팅 함수
    const formatPhoneNumber = (value: string) => {
        const numbersOnly = value.replace(/\D/g, "");
        const limitedNumbers = numbersOnly.slice(0, 11);
        if (limitedNumbers.length <= 3) return limitedNumbers;
        if (limitedNumbers.length <= 7) {
            return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
        }
        return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 7)}-${limitedNumbers.slice(7)}`;
    };
    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const formattedValue = formatPhoneNumber(inputValue);
        setManagerContact(formattedValue);
        setManagerContactError(false);
    };

    const formatTelNumber = (value: string, prevValue: string) => {
        const onlyNumbers = value.replace(/\D/g, "");
        let formatted = "";
        const maxLength = onlyNumbers.startsWith("02") ? 10 : onlyNumbers.startsWith("1") ? 8 : 11;
        if (onlyNumbers.length > maxLength) return prevValue;

        if (onlyNumbers.startsWith("02")) {
            if (onlyNumbers.length > 10) return prevValue;
            if (onlyNumbers.length <= 2) {
                formatted = onlyNumbers;
            } else if (onlyNumbers.length <= 6) {
                formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2)}`;
            } else {
                formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2, 6)}-${onlyNumbers.slice(6)}`;
            }
        } else if (onlyNumbers.startsWith("1")) {
            if (onlyNumbers.length > 8) return prevValue;
            if (onlyNumbers.length <= 4) {
                formatted = onlyNumbers;
            } else {
                formatted = `${onlyNumbers.slice(0, 4)}-${onlyNumbers.slice(4)}`;
            }
        } else if (/^[0-9]{7,8}$/.test(onlyNumbers)) {
            if (onlyNumbers.length > 8) return prevValue;
            formatted =
                onlyNumbers.length === 7
                    ? `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}`
                    : `${onlyNumbers.slice(0, 4)}-${onlyNumbers.slice(4, 8)}`;
        } else if (/^0\d{1,2}/.test(onlyNumbers)) {
            if (onlyNumbers.length > 11) return prevValue;
            if (onlyNumbers.length <= 3) {
                formatted = onlyNumbers;
            } else if (onlyNumbers.length <= 7) {
                formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
            } else {
                formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}-${onlyNumbers.slice(7)}`;
            }
        } else {
            formatted = onlyNumbers;
        }

        return formatted;
    };

    const handleContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const formattedValue = formatTelNumber(e.target.value, managerContact);
        setManagerContact(formattedValue);
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.addEventListener("scroll", handleScrollEvent);
        return () => container.removeEventListener("scroll", handleScrollEvent);
    }, [handleScrollEvent]);

    useEffect(() => {
        if (data) {
            setStatus(data.status);
            setCustomerName(data.customer_name);
            setZoneCode(data.customer_post || "");
            setAddress(data.customer_address || "");
            setDetailAddress(data.customer_address_detail || "");
            setOptions({
                event_content_option: data.event_content_option?.flag,
                related_person_option: data.related_person_option?.flag,
                work_location_option: data.work_location_option?.flag,
                department_option: data.department_option?.flag,
                union_option: data.union_option?.flag,
                company_tel_option: data.company_tel_option?.flag,
                wreath_sender_option: data.wreath_sender_option?.flag,
                wreath_word_option: data.wreath_word_option?.flag,
            });
        }
    }, [data]);

    useEffect(() => {
        if (Array.isArray(categoryData)) {
            setCategoryList([...categoryData]);
            setCheckedCategories(categoryData.filter(category => category.flag).map(category => category.product_category_idx)); // ✅ 초기값 설정
        }
    }, [id, categoryData]);

    useEffect(() => {
        if (Array.isArray(eventContentData)) {
            setEventContentList([...eventContentData]);
            setCheckedEventContents(eventContentData.filter(item => item.flag).map(item => item.event_content_idx));
        }
    }, [id, eventContentData]);

    // depth1별 그룹핑
    const eventContentGroups = eventContentList.reduce(
        (acc, item) => {
            if (!acc[item.depth1_idx]) {
                acc[item.depth1_idx] = { depth1: item.depth1, depth1_idx: item.depth1_idx, items: [] };
            }
            acc[item.depth1_idx].items.push(item);
            return acc;
        },
        {} as Record<number, { depth1: string; depth1_idx: number; items: GetCustomerEventContentResponse[] }>,
    );

    return (
        <div className="bg-gray6 p-4 flex flex-col gap-2 overflow-hidden">
            {/* Header */}
            <div className="bg-white rounded-xl px-4 py-2 flex flex-col gap-5 sticky top-0 z-50">
                <div className="flex items-center justify-between gap-4">
                    <p className="font-bold text-xl truncate">{data?.customer_name}</p>
                    {level === 7 || level === 8 || (
                        <Button onClick={handleDelete} status="error" size="S" className="px-2 whitespace-nowrap">
                            고객정보 삭제
                        </Button>
                    )}
                </div>
                <div className="flex items-center justify-between">
                    <div className="flex gap-1">
                        {sectionsRef.current.map(({ section, ref }) => (
                            <Button
                                key={section}
                                size="tag"
                                status={activeSection === section ? "regist" : ""}
                                onClick={() => handleScroll(ref, section)}
                            >
                                {section === "customer" && "고객정보"}
                                {section === "manager" && "담당자"}
                                {section === "owner" && "명의"}
                                {section === "category" && "상품 카테고리 설정"}
                            </Button>
                        ))}
                    </div>
                    <p className="text-sm text-primary2">클릭 시 해당 위치로 스크롤 이동</p>
                </div>
            </div>
            <div ref={containerRef} className="flex flex-col overflow-y-auto gap-2">
                {/* 고객정보 */}
                <div ref={customerRef} className="bg-white rounded-xl px-3 py-5 flex flex-col gap-5">
                    <div className="flex items-center justify-between">
                        <p className="text-xl font-bold">고객정보 - 고객</p>
                        <p className="text-sm text-gray2">{data?.reg_date} 등록</p>
                    </div>
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray2">기본정보</p>
                            <DownArrow
                                onClick={() => toggleSection("customer")}
                                className={`transform transition-transform cursor-pointer ${collapsedSections.customer ? "rotate-180" : ""}`}
                            />
                        </div>
                        {!collapsedSections.customer && (
                            <>
                                <div className="border-t-2 border-gray2">
                                    <div className="border-b border-gray4 flex items-center">
                                        <TableName required className="h-12">
                                            노출여부
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={status}
                                            onToggle={() => setStatus(!status)}
                                        />
                                    </div>
                                    <div className="border-b border-gray4 flex items-center">
                                        <TableName className="h-12">업체 개별 링크</TableName>
                                        <div className={`flex items-center p-2 gap-2 flex-1 ${status ? "opacity-100" : "opacity-[0.5]"}`}>
                                            <p className="text-xs text-gray2 truncate flex-1 select-all">{`${customerName} https://coryo1.co.kr/login-non-member?t=${id.toString(36)}`}</p>
                                            <button
                                                type="button"
                                                disabled={!status}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(`${customerName} https://coryo1.co.kr/login-non-member?t=${id.toString(36)}`).then(() => {
                                                        addToast({ type: "success", message: "업체 링크가 복사되었습니다." });
                                                    });
                                                }}
                                                className="shrink-0 flex items-center gap-1 text-xs bg-primary3 text-primary1 px-2.5 py-1.5 rounded-md"
                                            >
                                                <CopyIcon className="w-3.5 h-3.5" />
                                                링크 복사
                                            </button>
                                        </div>
                                    </div>
                                    <div className="border-b border-gray4 flex items-center">
                                        <TableName required className="h-12">
                                            거래처명
                                        </TableName>
                                        <Input
                                            placeholder="거래처명 입력"
                                            className="p-2 w-full"
                                            value={customerName}
                                            onChange={e => {
                                                // if (e.target.value.length <= 30) {
                                                setCustomerName(e.target.value);
                                                // }
                                                setCustomerNameError(false);
                                            }}
                                            status={customerNameError ? "error" : level === 7 ? "view" : undefined}
                                        />
                                    </div>
                                    <div className="border-b border-gray4 flex items-stretch">
                                        <TableName>주소</TableName>
                                        <NewOrderSearchAddress
                                            post={zoneCode}
                                            customerAddress={address}
                                            customerAddressDetail={detailAddress}
                                            onAddressChange={handleAddressChange}
                                            status={level === 7 ? "view" : undefined}
                                        />
                                    </div>
                                </div>
                                {level !== 7 && (
                                    <div className="flex w-full gap-2">
                                        <Button className="w-full" size="L" onClick={handleCancel}>
                                            취소
                                        </Button>
                                        <Button onClick={handleSave} status="regist" className="w-full" size="L">
                                            저장
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray2">화환 옵션 입력폼 노출 설정</p>
                            <DownArrow
                                onClick={() => toggleSection("option")}
                                className={`transform transition-transform cursor-pointer ${collapsedSections.option ? "rotate-180" : ""}`}
                            />
                        </div>
                        {!collapsedSections.option && (
                            <div className="border-t-2 border-gray2">
                                <div className="flex">
                                    <div className="flex items-center border-b w-full">
                                        <TableName required className="h-12">
                                            경조내용
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.event_content_option}
                                            onToggle={() => handleOptionToggle("event_content_option", 1)}
                                        />
                                    </div>
                                    <div className="flex items-center border-b w-full">
                                        <TableName required className="h-12">
                                            대상자명
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.related_person_option}
                                            onToggle={() => handleOptionToggle("related_person_option", 2)}
                                        />
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="flex items-center border-b w-full">
                                        <TableName required className="h-12">
                                            근무지
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.work_location_option}
                                            onToggle={() => handleOptionToggle("work_location_option", 3)}
                                        />
                                    </div>
                                    <div className="flex items-center border-b w-full">
                                        <TableName required className="h-12">
                                            부서
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.department_option}
                                            onToggle={() => handleOptionToggle("department_option", 4)}
                                        />
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="flex border-b w-full">
                                        <TableName required className="h-12">
                                            노동조합
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.union_option}
                                            onToggle={() => handleOptionToggle("union_option", 5)}
                                        />
                                    </div>
                                    <div className="flex border-b w-full">
                                        <TableName required className="h-12">
                                            사번
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.company_tel_option}
                                            onToggle={() => handleOptionToggle("company_tel_option", 6)}
                                        />
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="flex border-b w-full">
                                        <TableName required className="h-12">
                                            명의
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.wreath_sender_option}
                                            onToggle={() => handleOptionToggle("wreath_sender_option", 7)}
                                        />
                                    </div>
                                    <div className="flex border-b w-full">
                                        <TableName required className="h-12">
                                            경조사어
                                        </TableName>
                                        <Toggle
                                            disabled={level === 7}
                                            className="pl-2"
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={options.wreath_word_option}
                                            onToggle={() => handleOptionToggle("wreath_word_option", 8)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {options.event_content_option && (
                        <div className="flex flex-col gap-3">
                            <div className="flex items-center justify-between">
                                <p className="font-bold text-gray2">경조내용 설정</p>
                                <DownArrow
                                    onClick={() => toggleSection("eventContent")}
                                    className={`transform transition-transform cursor-pointer ${collapsedSections.eventContent ? "rotate-180" : ""}`}
                                />
                            </div>
                            {!collapsedSections.eventContent && (
                                <div className="flex flex-col gap-2">
                                    <p className="text-sm text-gray2">설정된 경조내용만 사용자 주문 페이지에 노출됩니다. 미설정 시 전체 노출.</p>
                                    <div className="text-sm flex gap-2">
                                        <p>총</p>
                                        <p className="text-primary2 font-bold">{checkedEventContents.length} 개 설정</p>
                                    </div>
                                    <div className="text-sm rounded-lg w-full border border-gray4 max-h-[400px] overflow-y-auto">
                                        {Object.values(eventContentGroups).map(group => (
                                            <div key={group.depth1_idx}>
                                                <div
                                                    className="flex items-center gap-2 px-2 py-3 bg-gray6 border-b border-gray4"
                                                    onClick={level === 7 ? undefined : () => handleEventContentSelectAllByDepth1(group.depth1_idx)}
                                                >
                                                    <CheckBox
                                                        disabled={level === 7}
                                                        checked={group.items.every(item =>
                                                            checkedEventContents.includes(item.event_content_idx),
                                                        )}
                                                    />
                                                    <p className="font-bold">{group.depth1}</p>
                                                </div>
                                                {group.items.map(item => (
                                                    <div
                                                        key={item.event_content_idx}
                                                        className="flex items-center gap-2 px-4 py-3 border-b border-gray4"
                                                        onClick={
                                                            level === 7
                                                                ? undefined
                                                                : () => handleEventContentChange(item.event_content_idx)
                                                        }
                                                    >
                                                        <CheckBox
                                                            disabled={level === 7}
                                                            checked={checkedEventContents.includes(item.event_content_idx)}
                                                        />
                                                        <p>{item.depth2 || item.depth1}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    {level !== 7 && (
                                        <div className="flex w-full gap-2">
                                            <Button onClick={handleEventContentUpdate} status="regist" className="w-full" size="L">
                                                저장
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    <div className="flex flex-col gap-3 ">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray2">메모</p>
                            <DownArrow
                                onClick={() => toggleSection("memo")}
                                className={`transform transition-transform cursor-pointer ${collapsedSections.memo ? "rotate-180" : ""}`}
                            />
                        </div>
                        {!collapsedSections.memo && (
                            <>
                                {level !== 7 && (
                                    <div className="flex items-center justify-between bg-gray6 p-3 rounded-xl gap-4">
                                        <textarea
                                            className="w-full text-sm py-1.5 rounded-lg h-8 outline-0 border px-3 flex resize-none overflow-hidden"
                                            placeholder="메모 100자"
                                            maxLength={100}
                                            value={customerMemo}
                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                const inputValue = e.target.value;
                                                setCustomerMemo(inputValue);
                                            }}
                                            onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                const target = e.target;
                                                target.style.height = "32px";
                                                target.style.height = `${Math.max(target.scrollHeight, 32)}px`;
                                            }}
                                        />
                                        <Button
                                            onClick={handleMemoSave}
                                            className="px-2.5 whitespace-nowrap h-full items-center flex"
                                            size="S"
                                            status="regist"
                                        >
                                            메모등록
                                        </Button>
                                    </div>
                                )}

                                {memoData &&
                                    memoData.data.map((memo, index) => (
                                        <div key={index} className="flex border-b gap-4 border-gray4 p-3 w-full">
                                            <div className="flex flex-col gap-2 w-full">
                                                {editIndex === memo.customer_memo_idx || (
                                                    <div className="flex gap-2 items-center">
                                                        <p className="text-sm text-gray2">{memo.member_name}</p>
                                                        <p className="text-xs text-gray3">{memo.reg_date}</p>
                                                    </div>
                                                )}

                                                {editIndex === memo.customer_memo_idx ? (
                                                    <textarea
                                                        className="w-full text-sm py-1.5 rounded-lg h-8 outline-0 border px-3 flex resize-none overflow-hidden"
                                                        placeholder="메모 100자"
                                                        value={editMemo}
                                                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                            const inputValue = e.target.value;
                                                            if (inputValue.length <= 100) {
                                                                setEditMemo(inputValue);
                                                            }
                                                        }}
                                                        onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                            const target = e.target;
                                                            target.style.height = "32px";
                                                            target.style.height = `${Math.max(target.scrollHeight, 32)}px`;
                                                        }}
                                                    />
                                                ) : (
                                                    <p className="text-sm">{memo.customer_memo}</p>
                                                )}
                                            </div>
                                            {level !== 7 &&
                                                (level !== 8 || memo.member_name === name) &&
                                                (editIndex === memo.customer_memo_idx ? (
                                                    <div className="flex items-center gap-1">
                                                        <Button size="S" className="px-2 whitespace-nowrap" onClick={handleMemoCancel}>
                                                            취소
                                                        </Button>
                                                        <Button
                                                            status="regist"
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleMemoModify(id, memo.customer_memo_idx)}
                                                        >
                                                            수정
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center gap-1">
                                                        <Button
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleEdit(memo.customer_memo_idx, memo.customer_memo)}
                                                        >
                                                            수정
                                                        </Button>
                                                        <Button
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleMemoDelete(id, memo.customer_memo_idx)}
                                                        >
                                                            삭제
                                                        </Button>
                                                    </div>
                                                ))}
                                        </div>
                                    ))}
                            </>
                        )}
                    </div>
                </div>
                {/* 담당자 */}
                <div ref={managerRef} className="bg-white rounded-xl flex flex-col">
                    <div className="p-3 flex items-center justify-between">
                        <p className="text-xl">담당자</p>
                        <div className="flex items-center gap-2 select-none">
                            <LeftArrow
                                className="cursor-pointer"
                                onClick={() => {
                                    if (currentPageManager > 1) {
                                        handleManagerPageChange(currentPageManager - 1);
                                    }
                                }}
                            />
                            <Input
                                className="w-20 text-center outline-0 text-sm"
                                inputClassName="text-center"
                                value={managerData?.total_count === 0 ? "0" : currentPageManager.toString()}
                                onChange={e => {
                                    const newValue = Number(e.target.value);
                                    if (managerData?.total_count === 0) {
                                        setCurrentPageManager(0);
                                    } else {
                                        setCurrentPageManager(newValue);
                                    }
                                }}
                            />
                            <p className="text-gray3">/ {managerData?.last_page}</p>
                            <RightArrow
                                className="cursor-pointer"
                                onClick={() => {
                                    if (currentPageManager < (managerData?.last_page || 1)) {
                                        handleManagerPageChange(currentPageManager + 1);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="border-t border-gray4 px-3 py-2 flex justify-between items-center">
                        <div className="flex gap-2 text-sm">
                            <p>총</p>
                            <p className="font-bold text-primary2">{managerData?.total_count}</p>
                        </div>
                        <div className="flex gap-2 ">
                            <div className="flex relative">
                                {level !== 7 && (
                                    <Button onClick={handleManagerAdd} size="S" status="regist" className="px-2">
                                        담당자 추가
                                    </Button>
                                )}

                                {managerPop && (
                                    <div className="w-[480px]  absolute bg-white shadow-custom mt-2 z-50 border translate-y-7 -translate-x-44 rounded-2xl">
                                        <div className="flex justify-between items-center py-5 px-6">
                                            <p className="text-primary1 text-2xl font-bold">담당자 추가</p>
                                            <CloseIcon
                                                className="cursor-pointer"
                                                onClick={() => {
                                                    setManagerName("");
                                                    setManagerEmail(null);
                                                    setManagerContact("");
                                                    setManagerPop(false);
                                                    setManagerNameError(false);
                                                    setManagerContactError(false);
                                                }}
                                            />
                                        </div>
                                        <div className="px-6 flex flex-col">
                                            <div className="border-t-2 border-[#666666]">
                                                <div className="flex items-center border-b border-gray4">
                                                    <TableName className="h-12" required>
                                                        담당자명
                                                    </TableName>
                                                    <Input
                                                        placeholder="20자"
                                                        maxLength={20}
                                                        className="w-full px-2"
                                                        value={managerName}
                                                        onChange={e => {
                                                            const inputValue = e.target.value;
                                                            if (inputValue.length <= 20) {
                                                                setManagerName(inputValue);
                                                            }
                                                            setManagerNameError(false);
                                                        }}
                                                        status={managerNameError ? "error" : undefined}
                                                    />
                                                </div>
                                                <div className="flex items-center border-b border-gray4">
                                                    <TableName className="h-12" required>
                                                        연락처
                                                    </TableName>
                                                    <Input
                                                        className="w-full px-2"
                                                        value={managerContact}
                                                        onChange={handleContactChange}
                                                        status={managerContactError ? "error" : undefined}
                                                    />
                                                </div>
                                                <div className="flex items-center border-b border-gray4">
                                                    <TableName className="h-12">이메일</TableName>
                                                    <Input
                                                        className="w-full px-2"
                                                        value={managerEmail || ""}
                                                        onChange={e => setManagerEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex w-full gap-2 py-5">
                                                <Button
                                                    onClick={() => {
                                                        setManagerName("");
                                                        setManagerEmail("");
                                                        setManagerContact("");
                                                        setManagerPop(false);
                                                        setManagerNameError(false);
                                                        setManagerContactError(false);
                                                    }}
                                                    className="w-full"
                                                    size="L"
                                                >
                                                    취소
                                                </Button>
                                                <Button onClick={handleManagerSave} status="regist" className="w-full" size="L">
                                                    저장
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <Input
                                placeholder="검색"
                                status="none"
                                className="w-60"
                                value={searchTxtManager}
                                onChange={e => setSearchTxtManager(e.target.value)}
                            />
                        </div>
                    </div>
                    <table className="text-sm table-fixed">
                        <thead className="h-10 border-t border-gray3">
                            <tr>
                                <th className="text-start px-2 ">담당자명</th>
                                <th className="text-start px-2">연락처</th>
                                <th className="text-start px-2">이메일</th>
                                {level !== 7 && level !== 8 && <th className="w-[102px]">기능</th>}
                            </tr>
                        </thead>

                        <tbody>
                            {managerData?.data_list.map(manager => (
                                <tr key={manager.customer_manager_idx} className="h-[50px] border-t border-gray4">
                                    <td className="px-2 max-w-[120px] w-[120px] truncate overflow-hidden">{manager?.manager_name}</td>
                                    <td className="px-2 max-w-[120px] w-[120px]">{manager?.manager_mobile}</td>
                                    <td className="px-2 max-w-[150px] w-[150px] truncate overflow-hidden">{manager?.manager_email}</td>
                                    {level !== 7 && level !== 8 && (
                                        <td className="flex gap-1 items-center justify-center h-[50px]">
                                            <div className="relative">
                                                <Button size="S" className="px-2" onClick={() => handleManagerEdit(manager)}>
                                                    수정
                                                </Button>
                                                {managerModifyPop === manager.customer_manager_idx && (
                                                    <div className="w-[480px] absolute right-0 translate-x-2 bg-white shadow-custom mt-1 z-50 border rounded-2xl">
                                                        <div className="flex justify-between items-center py-5 px-6">
                                                            <p className="text-primary1 text-2xl font-bold">담당자 수정</p>
                                                            <CloseIcon className="cursor-pointer" onClick={handleManagerEditClose} />
                                                        </div>
                                                        <div className="px-6 flex flex-col">
                                                            <div className="border-t-2 border-[#666666]">
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12" required>
                                                                        담당자명
                                                                    </TableName>
                                                                    <Input
                                                                        placeholder="20자"
                                                                        className="w-full px-2"
                                                                        value={managerName ?? manager.manager_name}
                                                                        onChange={e => {
                                                                            setManagerName(e.target.value);
                                                                            setManagerNameError(false);
                                                                        }}
                                                                        status={managerNameError ? "error" : undefined}
                                                                    />
                                                                </div>
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12" required>
                                                                        연락처
                                                                    </TableName>
                                                                    <Input
                                                                        className="w-full px-2"
                                                                        value={managerContact ?? manager.manager_mobile}
                                                                        onChange={handleContactChange}
                                                                        status={managerContactError ? "error" : undefined}
                                                                    />
                                                                </div>
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12">이메일</TableName>
                                                                    <Input
                                                                        className="w-full px-2"
                                                                        value={managerEmail ?? manager.manager_email}
                                                                        onChange={e => setManagerEmail(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="flex w-full gap-2 py-5">
                                                                <Button onClick={handleManagerEditClose} className="w-full" size="L">
                                                                    취소
                                                                </Button>
                                                                <Button
                                                                    onClick={handleManagerModify}
                                                                    status="regist"
                                                                    className="w-full"
                                                                    size="L"
                                                                >
                                                                    저장
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <Button
                                                onClick={() => handleManagerDelete(id, manager.customer_manager_idx)}
                                                size="S"
                                                className="px-2"
                                            >
                                                삭제
                                            </Button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* 명의 */}
                <div ref={ownerRef} className="bg-white rounded-xl flex flex-col">
                    <div className="p-3 flex items-center justify-between">
                        <p className="text-xl">명의</p>
                        <div className="flex items-center gap-2 select-none">
                            <LeftArrow
                                className="cursor-pointer"
                                onClick={() => {
                                    if (currentPageSender > 1) {
                                        handleSenderPageChange(currentPageSender - 1);
                                    }
                                }}
                            />
                            <Input
                                className="w-20 text-center outline-0 text-sm"
                                inputClassName="text-center"
                                value={senderData?.total_count === 0 ? "0" : currentPageSender.toString()}
                                onChange={e => {
                                    const newValue = Number(e.target.value);
                                    if (senderData?.total_count === 0) {
                                        setCurrentPageSender(0);
                                    } else {
                                        setCurrentPageSender(newValue);
                                    }
                                }}
                            />
                            <p className="text-gray3">/ {senderData?.last_page}</p>
                            <RightArrow
                                className="cursor-pointer"
                                onClick={() => {
                                    if (currentPageSender < (senderData?.last_page || 1)) {
                                        handleSenderPageChange(currentPageSender + 1);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="border-t border-gray4 px-3 py-2 flex justify-between items-center">
                        <div className="flex gap-2 text-sm">
                            <p>총</p>
                            <p className="font-bold text-primary2">{senderData?.total_count}</p>
                        </div>
                        <div className="flex gap-2">
                            <div className="flex relative">
                                {level !== 7 && (
                                    <Button onClick={handleSenderAdd} size="S" status="regist" className="px-2">
                                        명의 추가
                                    </Button>
                                )}
                                {senderPop && (
                                    <div className="w-[480px] absolute bg-white shadow-custom mt-2 z-50 border translate-y-7 -translate-x-44 rounded-2xl">
                                        <div className="flex justify-between items-center py-5 px-6">
                                            <p className="text-primary1 text-2xl font-bold">명의 추가</p>
                                            <CloseIcon className="cursor-pointer" onClick={handleSenderCancel} />
                                        </div>
                                        <div className="px-6 flex flex-col">
                                            <div className="border-t-2 border-[#666666]">
                                                <div className="flex items-center border-b border-gray4">
                                                    <TableName className="h-12" required>
                                                        노조여부
                                                    </TableName>
                                                    <Toggle
                                                        onLabel="하나만 설정가능합니다."
                                                        offLabel="하나만 설정가능합니다."
                                                        className="pl-2"
                                                        isOn={isUnionEnabled}
                                                        onToggle={() => {
                                                            if (!hasUnionOption) {
                                                                setIsUnionEnabled(prev => !prev);
                                                            }
                                                        }}
                                                        disabled={hasUnionOption}
                                                    />
                                                </div>
                                                <div className="flex items-center border-b border-gray4">
                                                    <TableName className="h-12" required>
                                                        기본명의
                                                    </TableName>
                                                    <Input
                                                        placeholder="기본명의 입력"
                                                        className="w-full px-2"
                                                        value={senderDefault}
                                                        onChange={e => {
                                                            setSenderDefault(e.target.value);
                                                            setSenderDefaultError(false);
                                                        }}
                                                        status={senderDefaultError ? "error" : undefined}
                                                    />
                                                </div>
                                                {isUnionEnabled && (
                                                    <div className="flex items-center border-b border-gray4">
                                                        <TableName className="h-12" required>
                                                            노조명의
                                                        </TableName>
                                                        <Input
                                                            placeholder="노조명의 입력"
                                                            // maxLength={30}
                                                            className="w-full px-2"
                                                            value={senderUnion}
                                                            onChange={e => {
                                                                setSenderUnion(e.target.value);
                                                                setSenderUnionError(false);
                                                            }}
                                                            status={senderUnionError ? "error" : undefined}
                                                        />
                                                    </div>
                                                )}
                                                {unionErrorMessage && (
                                                    <p className="text-error text-sm mt-1.5">이미 노동조합 명의가 동록되어 있습니다.</p>
                                                )}
                                            </div>
                                            <div className="flex w-full gap-2 py-5">
                                                <Button onClick={handleSenderCancel} className="w-full" size="L">
                                                    취소
                                                </Button>
                                                <Button onClick={handleSenderSave} status="regist" className="w-full" size="L">
                                                    저장
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <Input
                                placeholder="검색"
                                status="none"
                                className="w-60"
                                value={searchTxtSender}
                                onChange={e => setSearchTxtSender(e.target.value)}
                            />
                        </div>
                    </div>
                    <table className="text-sm">
                        <thead className="h-10 border-t border-gray3">
                            <tr>
                                <th className="text-start px-2">기본명의</th>
                                <th className="text-start px-2 w-[100px]">노출/숨김</th>
                                {level !== 7 && level !== 8 && <th className="w-[102px]">기능</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {senderData?.data_list.map((sender, index) => (
                                <tr key={`${sender.sender_idx}-${index}`} className="h-[50px] border-t border-gray4">
                                    <td className="px-2">
                                        {sender.default_sender} {sender.union_sender && "/"} {sender.union_sender}
                                    </td>
                                    <td className="px-2">
                                        <Toggle
                                            disabled={level === 7}
                                            onLabel="노출"
                                            offLabel="숨김"
                                            isOn={sender.status}
                                            onToggle={() => handleToggleStatus(sender.sender_idx, sender.status)}
                                        />
                                    </td>
                                    {level !== 7 && level !== 8 && (
                                        <td className="flex gap-1 items-center h-[50px]">
                                            <div className="relative">
                                                <Button size="S" className="px-2" onClick={() => handleSenderEdit(sender)}>
                                                    수정
                                                </Button>
                                                {senderModifyPop === sender.sender_idx && (
                                                    <div className="w-[480px] absolute right-0 translate-x-2 bg-white shadow-custom mt-1 z-50 border rounded-2xl">
                                                        <div className="flex justify-between items-center py-5 px-6">
                                                            <p className="text-primary1 text-2xl font-bold">명의 수정</p>
                                                            <CloseIcon className="cursor-pointer" onClick={handleSenderEditClose} />
                                                        </div>
                                                        <div className="px-6 flex flex-col">
                                                            <div className="border-t-2 border-[#666666]">
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12" required>
                                                                        노출/숨김
                                                                    </TableName>
                                                                    <Toggle
                                                                        onLabel="노출"
                                                                        offLabel="숨김"
                                                                        className="pl-2"
                                                                        isOn={isShowEnabled ?? sender.status}
                                                                        onToggle={() => setIsShowEnabled(prev => !prev)}
                                                                    />
                                                                </div>
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12" required>
                                                                        노조여부
                                                                    </TableName>
                                                                    <Toggle
                                                                        onLabel="하나만 설정가능합니다."
                                                                        offLabel="하나만 설정가능합니다."
                                                                        className="pl-2"
                                                                        isOn={isUnionEnabled ?? sender.union_option}
                                                                        onToggle={() => {
                                                                            setIsUnionEnabled(prev => !prev);
                                                                        }}
                                                                        disabled={!sender.union_option && hasUnionOption}
                                                                    />
                                                                </div>
                                                                <div className="flex items-center border-b border-gray4">
                                                                    <TableName className="h-12" required>
                                                                        기본명의
                                                                    </TableName>
                                                                    <Input
                                                                        placeholder="기본명의 입력"
                                                                        className="w-full px-2"
                                                                        value={senderDefault ?? sender.default_sender}
                                                                        onChange={e => {
                                                                            setSenderDefault(e.target.value);
                                                                            setSenderDefaultError(false);
                                                                        }}
                                                                        status={senderDefaultError ? "error" : undefined}
                                                                    />
                                                                </div>
                                                                {isUnionEnabled && (
                                                                    <div className="flex items-center border-b border-gray4">
                                                                        <TableName className="h-12" required>
                                                                            노조명의
                                                                        </TableName>
                                                                        <Input
                                                                            placeholder="노조명의 입력"
                                                                            className="w-full px-2"
                                                                            value={senderUnion ?? sender.union_sender}
                                                                            onChange={e => {
                                                                                setSenderUnion(e.target.value);
                                                                                setSenderUnionError(false);
                                                                            }}
                                                                            status={senderUnionError ? "error" : undefined}
                                                                        />
                                                                    </div>
                                                                )}
                                                                {unionModifyErrorMessage && (
                                                                    <p className="text-error text-sm mt-1.5">
                                                                        이미 노동조합 명의가 동록되어 있습니다.
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div className="flex w-full gap-2 py-5">
                                                                <Button onClick={handleSenderEditClose} className="w-full" size="L">
                                                                    취소
                                                                </Button>
                                                                <Button
                                                                    onClick={handleSenderModify}
                                                                    status="regist"
                                                                    className="w-full"
                                                                    size="L"
                                                                >
                                                                    저장
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <Button size="S" className="px-2" onClick={() => handleSenderDelete(id, sender.sender_idx)}>
                                                삭제
                                            </Button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* 상품 카테고리 설정 */}
                <div ref={categoryRef} className="bg-white rounded-xl flex flex-col py-5 px-3 gap-2">
                    <div className="flex items-center gap-1">
                        <p className="text-xl">상품 카테고리 설정</p>
                        <p className="text-sm text-primary2">설정된 카테고리만 사용자 페이지에 노출됩니다.</p>
                    </div>
                    <div className="text-sm flex gap-2">
                        <p>총</p>
                        <p className="text-primary2 font-bold">{checkedCategories.length} 개 설정</p>
                    </div>
                    <div className="text-sm rounded-lg w-full border border-gray4 max-h-[400px] overflow-y-auto">
                        <div className="flex items-center gap-2 px-2 py-3" onClick={level === 7 ? undefined : handleSelectAll}>
                            <CheckBox
                                checked={
                                    categoryList.length > 0 &&
                                    categoryList.every(category => checkedCategories.includes(category.product_category_idx))
                                }
                            />
                            <p className="font-bold">전체 선택</p>
                        </div>
                        {categoryList.map((category, index) => (
                            <div
                                onClick={() => (level === 7 ? undefined : handleCategoryChange(category.product_category_idx))}
                                key={`${category.product_category_idx}-${index}`}
                                className="flex items-center gap-2 px-2 py-3 border-t border-gray4"
                            >
                                <CheckBox disabled={level === 7} checked={checkedCategories.includes(category.product_category_idx)} />
                                <div className="flex items-center gap-1">
                                    <p className="font-bold">{category.category_name}</p>
                                    <p className="text-xs text-gray2">{category.wreath_option && "화환"}</p>
                                    <p className="text-xs text-gray2">{category.union_option && "노조"}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    {level !== 7 && (
                        <div className="flex w-full gap-2">
                            <Button onClick={handleCategoryUpdate} status="regist" className="w-full" size="L">
                                저장
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <SystemPop />
        </div>
    );
};

export default CustomerInfo;
